package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Switch
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.widgets.FilterCheckGroup
import io.horion.cv.components.widgets.FormRow
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.components.widgets.TextDescription
import io.horion.cv.components.widgets.TextFormFieldWhite
import io.horion.cv.models.Job
import io.horion.cv.models.JobType
import io.horion.cv.styles.TextDescriptionFormStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.label
import org.jetbrains.compose.web.css.px


@OptIn(DelicateApi::class)
@Composable
fun JobFormLayout1(state: Job,
                   onStateChange:(Job) -> Unit) {

    val breakpoint = rememberBreakpoint()

    Box(
        modifier = Modifier
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter // ✅ centre horizontalement
    ) {
        if (breakpoint <= Breakpoint.MD) {
            //  MOBILE → tout en colonne
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight(),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                GeneralInfoForm(state, onStateChange, modifier = Modifier.weight(1f))
                DescriptionForm(state, onStateChange, modifier = Modifier.weight(1f))
            }
        } else {
            // DESKTOP → 2 colonnes
            // DESKTOP → layout en lignes (propre & pro)
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(10.px),
                verticalArrangement = Arrangement.spacedBy(24.px)
            ) {

                //  SECTION INFOS GENERALES
                GeneralInfoForm(
                    state = state,
                    onStateChange = onStateChange,
                    modifier = Modifier.fillMaxWidth()
                )

                //  SECTION DESCRIPTION
                DescriptionForm(
                    state = state,
                    onStateChange = onStateChange,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun GeneralInfoForm(
    state: Job,
    onStateChange: (Job) -> Unit,
    modifier: Modifier
) {

    var selectedJobTypes by remember { mutableStateOf(listOf(JobType.CDI)) }
    val breakpoint = rememberBreakpoint()

    Box(
        modifier = modifier
            .fillMaxWidth()
            .borderRadius(12.px)
            .padding(15.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(10.px),
            verticalArrangement = Arrangement.spacedBy(16.px)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().gap(20.px),
                verticalAlignment = Alignment.CenterVertically
            ) {

                //  TITRE DU JOB
                Box(modifier = Modifier.flex(1)) {
                    FormRow(
                        label = "Titre du poste",
                        breakpoint = breakpoint
                    ) {
                        TextFormFieldWhite(
                            value = state.title,
                            onValueChange = { newTitle ->
                                onStateChange(state.copy(title = newTitle))
                            },
                            placeholder = "Développeur web",
                        )
                    }
                }

                // teletravail
                Box(modifier = Modifier.flex(1)) {

                    FormRow(
                        label = "Travail à distance",
                        breakpoint = breakpoint
                    ) {
                        Switch(
                            checked = state.isRemote,
                            onCheckedChange = { isChecked ->
                                onStateChange(state.copy(isRemote = isChecked))
                            }
                        )
                    }
                }
            }
            Row(
                modifier = Modifier.fillMaxWidth().gap(20.px),
                verticalAlignment = Alignment.CenterVertically
            ) {

                //  VILLE
                Box(modifier = Modifier.flex(1)) {
                    FormRow(
                        label = "Ville",
                        breakpoint = breakpoint
                    ) {
                        TextFormFieldWhite(
                            value = state.city,
                            onValueChange = { newCity ->
                                onStateChange(state.copy(city = newCity))
                            },
                            placeholder = "Yaoundé",
                        )
                    }
                }

                // type de travail
                Box(modifier = Modifier.flex(1)) {

                    FormRow(
                        label = "Type du poste",
                        breakpoint = breakpoint
                    ) {
                        FilterCheckGroup(
                            title = "",
                            items = JobType.entries,
                            checkedItems = selectedJobTypes,
                            onCheckedChange = { item, isChecked ->
                                if (isChecked) {
                                    selectedJobTypes + item
                                } else {
                                    selectedJobTypes - item
                                }
                            },
                            label = { it.label() },
                            breakpoint = breakpoint
                        )
                    }
                }
            }
        }
    }
}


@OptIn(DelicateApi::class)
@Composable
fun DescriptionForm(
    state: Job,
    onStateChange: (Job) -> Unit,
    modifier: Modifier
) {

    val breakpoint = rememberBreakpoint()

    Column(
        modifier = modifier
            .fillMaxWidth()
            .padding(10.px),
        verticalArrangement = Arrangement.spacedBy(16.px)
    ) {
        FormRow(
            label = "Description",
            breakpoint = breakpoint
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(10.px)
            ) {
                TextDescription(
                    label = "",
                    value = state.description,
                    onValueChange = {onStateChange(state)},
                    isMobile = breakpoint < Breakpoint.SM,
                    isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD,
                    modifier = TextDescriptionFormStyle.toModifier()
                )
            }
        }

        FormRow(
            label = "Responsabilités",
            breakpoint = breakpoint
        ) {
            ResponsabilityContent()
        }
    }
}
